import { Flex } from 'antd';
import { useInjection } from 'inversify-react';
import { useMemo } from 'react';

import { Button, Icon, Text, useTheme } from '@desygner/ui-common-components';
import { useTranslation } from '@desygner/ui-common-translation';

import { RestrictionsManager } from '../../../../../../core/viewer/restrictions-manager';
import { TYPES } from '../../../../../../inversify.types';
import { IViewerStoreInjector } from '../../../../../../store';

export type EditProjectProps = {
  type: 'bottomsheet' | 'desktop';
};

export const EditProject = ({ type }: EditProjectProps) => {
  const theme = useTheme();
  const restrictionsManager = useInjection<RestrictionsManager>(TYPES.Viewer.RestrictionsManager);
  const { t } = useTranslation();
  const useViewerStore = useInjection<IViewerStoreInjector>(TYPES.Store.Viewer);
  const projectType = useViewerStore((state) => state.project.type);

  function handleEditExistingTemplate() {
    restrictionsManager.navigateToProjectEditor();
  }

  const buttonLabel = useMemo(
    () =>
      projectType === 'template'
        ? t('tool.topbar.edit_template_button')
        : t('tool.topbar.edit_button'),
    [projectType, t]
  );

  if (type === 'desktop') {
    return (
      <Button
        action="edit-existing-template"
        onClick={handleEditExistingTemplate}
        variant="primary"
      >
        {buttonLabel}
      </Button>
    );
  }

  return (
    <Flex data-testid="edit-project" data-action={'edit-existing-template'} role="button" onClick={handleEditExistingTemplate}>
      <Flex gap={theme.Sizes.Small} flex={1}>
        <Icon name="edit---square" color={theme.Color.Neutrals.Text} />
        <Text size="Body">{buttonLabel}</Text>
      </Flex>
    </Flex>
  );
};
